import './sass';
import './Affix'; // 固钉
import './Article'; // 文章
// import './Backendmain';
import './Btn'; // 按钮
import './Block'; // 区块
import './Carousel'; // 轮播
import './Crumbs'; // 面包屑
import './Font'; // 字体
import './ListLink'; // 新闻列表
import './Footer'; // 页尾
import './Header'; // 页头
import './PicNews'; // 图片新闻
// import './Tab'; // 标签
import './Iconlink'; // 图标链接
import './Listpic'; // 图片新闻
import './Common';
import './Login'; // 登陆
import './Placeholder';
import './Search'; // 搜索
import './Menu'; // 菜单
import './Input';
// import './Form';
import './Pagination'; // 分页
import './Layer'; // 弹出层
// import './Rating';
import './Nav'; // 导航
import './Card'; // 卡片
import './Table'; // 表格
import './Category'; // 栏目
import './Datepick';



/** WEBPACK FOOTER **
 ** ./components/main.js
 **/